export default (function (_ref) {
  var request = _ref.request;
  return {
    feedBaitRecordQuery: function feedBaitRecordQuery(data) {
      return request({
        url: '/feed/fdrDeviceLog',
        method: 'get',
        params: data
      });
    }
  };
});